import TextInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextInput';
import useFilters, { IFilterList } from '@oncolens/oncolens-ui/lib/hooks/common/Table/useFilters';
import useDebounce from '@oncolens/oncolens-ui/lib/hooks/common/useDebounce';
import React, { useEffect, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { MobileUsersTable, UsersTable } from '../components/UsersTable';

export interface UserFilters extends IFilterList {
  search: string;
}

export const UsersPage = () => {
  const [inputValue, setInputValue] = useState('');
  const navigate = useNavigate();
  const [queryParameters] = useSearchParams();
  const { updateFilters, filters } = useFilters<UserFilters>({
    transformers: {
      search: 'string',
    },
    queryParameters,
  });

  const debouncedSearch = useDebounce((value: string) => {
    updateFilters({ search: value }, navigate);
  }, 500);

  useEffect(() => {
    if (filters.search !== inputValue) {
      setInputValue(filters.search);
    }
  }, []);

  return (
    <div className="max-w-7xl">
      <div className="flex items-center my-3">
        <h1 className="ml-1 text-3xl font-semibold">Users</h1>
        <div className="relative w-1/3 ml-auto">
          <BsSearch className="absolute left-2.5 top-2.5 text-gray-700 z-10" />
          <TextInput
            placeholder="Search"
            label="search"
            srLabel={true}
            inputProps={{ className: 'pl-8' }}
            type="text"
            id="orgListSearch"
            htmlName="orgListSearch"
            value={inputValue}
            onChange={(event: any) => {
              const value = event.target.value as string;

              setInputValue(value);
              debouncedSearch(value);
            }}
          />
        </div>
      </div>

      <div className="hidden md:block">
        <UsersTable filters={filters} />
      </div>
      <div className="md:hidden">
        <MobileUsersTable filters={filters} />
      </div>
    </div>
  );
};
